// extracted by mini-css-extract-plugin
export var bodySections = "_c7-8";
export var gray = "_c7-7";
export var green = "_c7-4";
export var iconContainer = "_c7-9";
export var iconWidgetContainer = "_c7-1";
export var phoneIcon = "_c7-2";
export var red = "_c7-5";
export var statusDot = "_c7-3";
export var widgetContainer = "_c7-0";
export var yellow = "_c7-6";